export const SERVICES = {
  AUTH_NIP: '/marketplace/apps/cc/authnip/map',

  CATALOGS_ZIPCODE: '/private/codecatalog/code',

  COMPANY: '/private/company',

  CONNECTOR_CORE: '/internal/connector/:company/core',
  CONNECTOR_FLOW: '/internal/connector/:company/flows/:flow',

  CREDIT_HISTORY_CHECK_GENERATE: '/marketplace/apps/tools/verificationCode/generate',
  CREDIT_HISTORY_CHECK_VALIDATION: '/marketplace/apps/tools/verificationCode/validation',
  
  EKATENA_REPORTS: '/marketplace/apps/ekatena/reports',
  
  JUMIO_VERIFICATION: '/marketplace/apps/jumio',

  NOTIFICATIONS_FORMS: '/private/notifications/forms',
  NOTIFICATIONS_FORMS_DATA: '/private/notifications/forms_data',
  NOTIFICATIONS_SURVEY: '/private/notifications/survey',
  NOTIFICATIONS_SURVEY_RELATION: '/private/notifications/survey_relation',

  PEOPLE: '/private/clients',
  PEOPLE_ORGANIZATIONAL: '/private/clients/organizational/v2',
  PEOPLE_ORGANIZATIONAL_OLD: 'private/clients/organizational',
  PEOPLE_SIMPLE_TYPES: '/private/clients/simple-types',
  PEOPLE_RELATIONSHIP: '/private/clients/relationship',
  PEOPLE_TYPES: '/private/clients/types',
  
  SEND_EMAIL: '/internal/connector/3317/flows/df564e36e2c54a02be70ca63e9b97fd2',

  USERS_GET_INFO: '/private/users/get_info',
  USERS_UPDATE_ATTRIBUTES: '/users/updateUserAttributes',
  USERS_WEBCLIENTS: '/users/webclients',
  USERS_SIGNIN_DOCUMENT: '/users/signin_documents',
  USERS_PRESIGNIN_DOCUMENT: '/users/presignin_documents',
  USERS_CHECK_DOCUMENT: '/users/checkKeyExist',

  WS_PUBLISH: '/internal/wspublish',
};

export const CONF = {
  [SERVICES.PEOPLE_TEMPLATES]: {
    getById: false,
    sort: 'score',
  },
  [SERVICES.DASHBOARD_CHARTS_DATA]: {
    getById: false,
  },
};
